/// <amd-module name="VSSUI/Components/Panel/PanelHeader" />
import * as React from "react";

import { IPanelHeaderProps, PanelCloseButtonSize } from "VSSUI/Components/Panel/Panel.Props";

import * as Resources from "VSSUI/Resources.Layer";
import { Header, TitleSize } from "VSSUI/Header";
import { css } from "VSSUI/Util";

let closeButtonId = 1;

export const PanelHeader: React.SFC<IPanelHeaderProps> = props => {
    const { backButtonProps, description, onDismiss, closeButtonSize, showCloseButton, showSeparator, titleProps = {} } = props;
    if (props.children) {
        return (
            <>
                <div className={css(props.className, "bolt-panel-header flex-noshrink flex-column scroll-hidden")}>{props.children}</div>
                {showSeparator && <div className="bolt-panel-separator flex-noshrink" />}
            </>
        );
    }
    const commandBarItems = [];
    if (showCloseButton !== false) {
        commandBarItems.push({
            ariaLabel: Resources.Close,
            iconProps: { iconName: closeButtonSize === PanelCloseButtonSize.small ? "Cancel" : "Clear" },
            id: `close-button-${closeButtonId++}`,
            role: "button",
            onActivate: onDismiss,
            subtle: true
        });
    }
    return (
        <Header
            backButtonProps={backButtonProps}
            className={css(props.className, "bolt-panel-header")}
            commandBarItems={commandBarItems}
            description={description}
            separator={showSeparator}
            title={titleProps.text}
            titleClassName={titleProps.className}
            titleId={titleProps.id}
            titleSize={titleProps.size === undefined ? TitleSize.Large : titleProps.size}
            titleIconProps={titleProps.iconProps}
        />
    );
};
